import React from 'react'
import { Icon } from '@therms/atalaya'
import { MobileMenuLink } from '@src/modules/Layout/shared/MobileMenuLink'
import { BULLETINS_ROUTES } from '../../constants'
import { MdDashboard } from 'react-icons/md'

function BulletinsMobileMenuLink() {
  return (
    <MobileMenuLink to={BULLETINS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={MdDashboard} />
        <span className="grow">Bulletins</span>
      </div>
    </MobileMenuLink>
  )
}

export { BulletinsMobileMenuLink }
